import { Spot } from './tour-anchor';

/** Le coin où se tient le panneau du parcours. */
export type Corner = 'bottom-right' | 'bottom-left' | 'top-left' | 'top-right';

/**
 * Par ordre de préférence. Le coin haut droit vient en dernier : c'est celui de l'avertissement
 * de version (RG-version-avertissement-jusqu-au-rechargement).
 */
const CORNERS: Corner[] = ['bottom-right', 'bottom-left', 'top-left', 'top-right'];

/** L'écart entre le panneau et le bord de la fenêtre, en pixels. */
export const PANEL_GAP = 16;

interface Size {
  width: number;
  height: number;
}

function panelSpot(corner: Corner, panel: Size, viewport: Size): Spot {
  const left = corner.endsWith('left') ? PANEL_GAP : viewport.width - PANEL_GAP - panel.width;
  const top = corner.startsWith('top') ? PANEL_GAP : viewport.height - PANEL_GAP - panel.height;
  return { left, top, ...panel };
}

function overlaps(a: Spot, b: Spot): boolean {
  return (
    a.left < b.left + b.width &&
    b.left < a.left + a.width &&
    a.top < b.top + b.height &&
    b.top < a.top + a.height
  );
}

/**
 * Le premier coin où le panneau ne recouvre pas l'élément en surbrillance ; le coin préféré
 * quand il n'y en a pas, ou quand aucun ne convient.
 */
export function cornerAvoiding(spot: Spot | null, panel: Size, viewport: Size): Corner {
  if (!spot) return CORNERS[0];
  return (
    CORNERS.find((corner) => !overlaps(panelSpot(corner, panel, viewport), spot)) ?? CORNERS[0]
  );
}
